import Cookies from 'js-cookie'

/** 获取cookie */
export const getCookie = cname => {
    const name = cname + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

/** 设置cookie */
export const setCookie = (cname, cvalue, exdays) => {
    Cookies.set(cname, cvalue, { expires: exdays, path: '/' })
    // const d = new Date()
    // d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000 + exSeconds * 1000)
    // const expires = 'expires=' + d.toUTCString()
    // document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

/** 删除cookie */
export const deleteCookie = cname => {
    document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}
